export default __webpack_public_path__ + "static/media/topazcoin.e40a0b19.png";